"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferService = void 0;
const APIService_1 = require("./APIService");
const getHomeOffers = () => APIService_1.APIService.get(`/offers?size=6&promotion=true`);
const getFavouriteOffers = (ids) => APIService_1.APIService.get(`/offers/favourite?ids=${ids}`);
const getOffers = (params) => {
    return APIService_1.APIService.get(`/offers`, {
        params: params,
    });
};
const getOffersCount = (params) => {
    return APIService_1.APIService.get(`/offers-count`, {
        params: params,
    });
};
const getDealerOffers = (slug, params) => {
    return APIService_1.APIService.get(`/${slug}/offers`, {
        params: params,
    });
};
const getOffer = (id, params = {}) => APIService_1.APIService.get(`/offers/${id}`, {
    params: params,
});
const getOfferCoordinator = (id) => APIService_1.APIService.get(`/offers/${id}/coordinator`);
exports.OfferService = {
    getHomeOffers,
    getFavouriteOffers,
    getOffers,
    getOffersCount,
    getDealerOffers,
    getOffer,
    getOfferCoordinator,
};
//# sourceMappingURL=OfferService.js.map